import React from 'react';
import { FamilyMember } from '@/types';
import { EmptyState } from './EmptyState';
import { TreeConnectors } from './TreeConnectors';
import { TreeNodes } from './TreeNodes';

interface TreeCanvasProps {
  members: FamilyMember[];
  nodePositions: Map<string, { x: number; y: number }>;
  dimensions: { width: number; height: number };
  contentDimensions: { width: number; height: number };
  scale: number;
  position: { x: number; y: number };
  isDragging: boolean;
  nodeWidth: number;
  nodeHeight: number;
  onEditNode?: (member: FamilyMember) => void;
  onDeleteNode?: (member: FamilyMember) => void;
  onAddChild?: (member: FamilyMember) => void;
  onAddFirstMember?: () => void;
  isAdmin: boolean;
}

export function TreeCanvas({
  members,
  nodePositions,
  dimensions,
  contentDimensions,
  scale,
  position,
  isDragging,
  nodeWidth,
  nodeHeight,
  onEditNode,
  onDeleteNode,
  onAddChild,
  onAddFirstMember,
  isAdmin,
}: TreeCanvasProps) {
  if (!members?.length || !nodePositions?.size) {
    return (
      <EmptyState 
        isAdmin={isAdmin} 
        onAddClick={onAddFirstMember!}
      />
    );
  }

  return (
    <div className="absolute inset-0 overflow-hidden">
      <svg
        width={contentDimensions.width}
        height={contentDimensions.height}
        className="absolute top-0 left-0"
        style={{
          transform: `translate(${position.x}px, ${position.y}px) scale(${scale})`,
          transformOrigin: '0 0',
          transition: isDragging ? 'none' : 'transform 0.1s ease-out',
        }}
      >
        <g>
          <TreeConnectors
            members={members}
            nodePositions={nodePositions}
            nodeWidth={nodeWidth}
            nodeHeight={nodeHeight}
          />
          <TreeNodes
            members={members}
            nodePositions={nodePositions}
            nodeWidth={nodeWidth}
            nodeHeight={nodeHeight}
            onEditNode={onEditNode}
            onDeleteNode={onDeleteNode}
            onAddChild={onAddChild}
            isAdmin={isAdmin}
          />
        </g>
      </svg>
    </div>
  );
}